import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'
import { IsNullOrEmpty } from '@/modules/helper'
const state = {
  Twitter: {
    'Id': 0,
    'RowCreated': '',
    'RowUpdated': '',
    'TwitterToken': '',
    'SubscriptionModule_Id': 0,
    'PageTitle': '',
    'TwitterId': '',
    'Module_Id': 0,
    'ConsumerKey': '',
    'ConsumerSecretKey': '',
    'AccessToken': '',
    'AccessTokenSecretKey': ''
  }
}
const getters = {
  Twitter: state => state.Twitter,
  TwitterErrorFound: state => state.TwitterErrorFound
}
const mutations = {
  [mutationNames.SET_TWITTER_PARENT] (state, Parent) {
    state.Twitter = Parent
  },
  [mutationNames.SET_TWITTER_ERRORFOUND] (state, ErrorCode) {
    state.TwitterErrorFound = ErrorCode
  },
  [mutationNames.UPDATE_TWITTERDATA] (state, obj) {
    Object.assign(state.Twitter, obj)
  }
}
const actions = {
  updateTwitterSettings ({ commit, getters }, payload) {
    commit(mutationNames.UPDATE_TWITTERDATA, payload)
  },
  async getTwitterModule ({ commit, getters }, SubscriptionModuleId) {
    const response = await api.AppModules.GetTwitterInfo(SubscriptionModuleId)
    commit(mutationNames.SET_TWITTER_PARENT, response)
    return response
  },
  async getTwitterUserInfo ({ commit, getters }, payload) {
    const response = await api.AppModules.GetTwitterUserInfo(payload)
    if (IsNullOrEmpty(response.ErrorCode)) {
      return response.User
    }
    return response.ErrorCode
  },
  async getTwitterUsers ({ commit, getters }, payload) {
    const response = await api.AppModules.SearchTwitterUsers(payload)
    if (IsNullOrEmpty(response.ErrorCode)) {
      return response.Users
    }
    return response.ErrorCode
  },
  async saveTwitterSettings ({ dispatch, getters }) {
    let TwitterClone = Object.assign({}, getters.Twitter)
    await api.AppModules.SaveTwitterInfo(TwitterClone)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/appModules/twitter.js